import {ExclamationTriangleIcon} from "@heroicons/react/24/outline";
import {WARNING_TAG_TEXT} from "../utils/rowWarnings.ts";

export function AccountWarningsNotice({visible}: {visible: boolean}) {
    if (!visible) return null;

    return (
        <div className="mb-4 flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-3">
            <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0 text-amber-600" />
            <div className="text-sm text-amber-800">
                Sommige rekeningen horen niet thuis in dit overzicht. De boekingen
                worden wel getoond - klap de rubrieken uit en zoek naar het label{" "}
                <span className="font-medium">{WARNING_TAG_TEXT}</span>.
            </div>
        </div>
    );
}
